import { useMemo } from 'react';
import dayjs from 'dayjs';
import { getScheduleName } from 'wb-spotify/app/routes/reports/utils';
import { SpotifyReportSchedule } from 'wb-spotify/app/common/utils';

const useTransformSpotifySchedule = (selectedSchedule?: SpotifyReportSchedule) => {
	const scheduleName = useMemo(() => getScheduleName(selectedSchedule), [selectedSchedule]);

	const scheduleTimeUnit = useMemo((): dayjs.ManipulateType | undefined => {
		switch (selectedSchedule) {
			case SpotifyReportSchedule.OnlyOnce:
				return 'day';
			case SpotifyReportSchedule.EveryMonday:
			case SpotifyReportSchedule.EveryWeekday:
				return 'week';
			case SpotifyReportSchedule.FirstOfTheMonth:
				return 'month';
			default:
				return undefined;
		}
	}, [selectedSchedule]);

	const scheduleTimeValue = useMemo(() => {
		switch (selectedSchedule) {
			case SpotifyReportSchedule.OnlyOnce:
			case SpotifyReportSchedule.EveryMonday:
			case SpotifyReportSchedule.EveryWeekday:
			case SpotifyReportSchedule.FirstOfTheMonth:
				return 1;
			default:
				return null;
		}
	}, [selectedSchedule]);

	return {
		scheduleName, scheduleTimeUnit, scheduleTimeValue,
	};
};

export default useTransformSpotifySchedule;
